import { CampoOrientacaoCompleta } from "./types";

const CAMPOS_ORDEM: Array<{ key: string; label: string }> = [
    { key: "parte_representada", label: "Qual parte representamos" },
    { key: "nome_advogado", label: "Nome do advogado" },
    { key: "oab_advogado", label: "OAB do advogado" },
    { key: "nome_preposto", label: "Nome do preposto" },
    { key: "proposta_acordo", label: "Proposta de acordo" },
    { key: "requerimentos", label: "Requerimentos a realizar em audiência" },
    { key: "documentos", label: "Documentos a juntar" },
    { key: "testemunhas", label: "Testemunhas a ouvir" },
    { key: "pedidos", label: "Pedidos relevantes da inicial" },
    { key: "resumo_contestacao", label: "Resumo da contestação" },
    { key: "outras_informacoes", label: "Outras informações" },
    { key: "status", label: "Status da orientação" }
];

const labelPorChave: Record<string, string> = CAMPOS_ORDEM.reduce((acc, item) => {
    acc[item.key] = item.label;
    return acc;
}, {} as Record<string, string>);

const parseJson = (valor: any) => {
    if (typeof valor === "string") {
        try {
            return JSON.parse(valor);
        } catch {
            return null;
        }
    }
    return valor;
};

const formatarTexto = (valor: any): string => {
    if (valor === null || valor === undefined) {
        return "—";
    }

    if (typeof valor === "string") {
        const texto = valor.trim();
        return texto.length > 0 ? texto : "—";
    }

    if (typeof valor === "number") {
        return String(valor);
    }

    return String(valor ?? "—");
};

export const mapearCamposOrientacaoCompleta = (dadosAntes: any, dadosDepois: any): CampoOrientacaoCompleta[] => {
    if (!dadosDepois) {
        return [];
    }

    const antesNormalizado = dadosAntes ? (parseJson(dadosAntes) || dadosAntes) : null;
    const depoisNormalizado = parseJson(dadosDepois) || dadosDepois;

    if (!depoisNormalizado || typeof depoisNormalizado !== "object" || Array.isArray(depoisNormalizado)) {
        return [];
    }

    const campos: CampoOrientacaoCompleta[] = [];

    for (const key in depoisNormalizado) {
        if (Object.prototype.hasOwnProperty.call(depoisNormalizado, key)) {
            const valorAntes = antesNormalizado && typeof antesNormalizado === "object" ? antesNormalizado[key] : undefined;
            const valorDepois = depoisNormalizado[key];

            campos.push({
                campo: labelPorChave[key] || key,
                antes: formatarTexto(valorAntes),
                depois: formatarTexto(valorDepois)
            });
        }
    }

    return campos;
};


